import React, { useMemo } from 'react'
import { ApolloProvider } from '@apollo/client/react'
import type { ReactNode } from 'react'
import { setupApolloClient } from '../../config/graphql'
import { useMounted } from '../../hooks/useMounted'
import { InvoiceContainer } from '../invoice/InvoiceContainer'

// Browser-only, like the owner's invoice page: the layout's Header needs an ApolloProvider, and a link
// page signs nobody in — the client carries no token, so it reads nothing on its own.
export const InvoiceViewShell = ({ children }: { children: ReactNode }) => {
  const mounted = useMounted()
  const client = useMemo(() => setupApolloClient({ accessToken: '', uri: '/graphql?tenantId=DFT' }), [])

  if (!mounted) return null

  return (
    <ApolloProvider client={client}>
      <InvoiceContainer>{children}</InvoiceContainer>
    </ApolloProvider>
  )
}
